import {
  EvaluateSupportConversationRequest,
  UpdateAllCommentStatusRequest,
  UpdateAllPostStatusRequest,
  UpdateCommentStatusRequest,
  UpdatePostStatusRequest,
  ViewApprovalCountRequest,
  ViewApprovalMembersRequest,
  ViewApprovalsForUserRequest,
  ViewApprovalsRequest
} from './approval.types';

import { API_HOST, HttpGetOptions, getHttpGetOptions } from '../../utils/api.util';

const getEndpoint = () => `${API_HOST}/approval`;

export const getViewApprovalCountRequest = (data: ViewApprovalCountRequest): [string, HttpGetOptions] => [
  `${getEndpoint()}/detail/count/${data.programmeExternalReference}`,
  getHttpGetOptions()
];

export const getViewApprovalMembersRequest = (data: ViewApprovalMembersRequest): [string, HttpGetOptions] => [
  `${getEndpoint()}/detail/${data.programmeExternalReference}`,
  getHttpGetOptions()
];

export const getViewApprovalsRequest = (data: ViewApprovalsRequest): [string, HttpGetOptions] => [
  `${getEndpoint()}/view/${data.programmeExternalReference}`,
  getHttpGetOptions(undefined, { type: data.type, status: data.status })
];

export const getUpdatePostStatusRequest = (data: UpdatePostStatusRequest): [string, HttpGetOptions] => [
  `${getEndpoint()}/post/${data.programmeExternalReference}/${data.postExternalReference}`,
  getHttpGetOptions(undefined, { status: data.status })
];

export const getUpdateCommentStatusRequest = (data: UpdateCommentStatusRequest): [string, HttpGetOptions] => [
  `${getEndpoint()}/comment/${data.programmeExternalReference}/${data.commentExternalReference}`,
  getHttpGetOptions(undefined, { status: data.status })
];

export const getUpdateAllPostStatusRequest = (data: UpdateAllPostStatusRequest): [string, HttpGetOptions] => [
  `${getEndpoint()}/posts/${data.programmeExternalReference}/${data.systemUserExternalReference}`,
  getHttpGetOptions(undefined, { status: data.status })
];

export const getUpdateAllCommentStatusRequest = (data: UpdateAllCommentStatusRequest): [string, HttpGetOptions] => [
  `${getEndpoint()}/comments/${data.programmeExternalReference}/${data.systemUserExternalReference}`,
  getHttpGetOptions(undefined, { status: data.status })
];

export const getViewApprovalsForUserRequest = (data: ViewApprovalsForUserRequest): [string, HttpGetOptions] => [
  `${getEndpoint()}/view/${data.programmeExternalReference}/${data.systemUserExternalReference}`,
  getHttpGetOptions()
];

export const getEvaluateSupportConversationRequest = (
  data: EvaluateSupportConversationRequest
): [string, HttpGetOptions] => [
  `${getEndpoint()}/contact/${data.programmeExternalReference}/${data.systemUserExternalReference}`,
  getHttpGetOptions()
];
